import { http } from '@/shared/https';
import Vue from 'vue';

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 2,
        parentComponent: true,
        card: {
            type: 'Form'
        },
        hideButtons: ['Delete'],
        actions: {
            listAction: "/api/UsefulDocument/GetUsefulDocumentDetail/",
            deleteAction: "/api/UsefulDocument/",
            updateAction: "/api/UsefulDocument",
            createAction: "/api/UsefulDocument"
        },
        fields: {
            UsefulDocumentId: {
                primaryKey: true
            },
            ProgramId: {
                type: "ComboBox",
                autocomplete: true,
                required: true,
                title: "Program",
            },
            DocId: {
                type: "ComboBox",
                autocomplete: true,
                required: true,
                title: "Document type",
            },
            Language: {
                type: "ComboBox",
                autocomplete: true,
                uploadName:"Language",
                required: true,
                title: "Language",
            },
            Initiative: {
                title: "Initiative",
                required: true,
                type: "TextInput",
                autocomplete: true,
            },
            FileName: {
                type: "TextInput",
                required: true,
                title: "File name",
            },
            Link: {
                type: "TextInput",
                title: "Link",
                required: true,
                sortable: true,
            }
        },
    },

    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) { },

        //#. fn_formCancel function
        formCancel(state, payload) { },

        //#. fn_recordCreated function
        recordCreated(state, payload) { },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) { },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) { },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) { },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) { },

    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },

        workFlowStatusIdChange: ({ commit, rootState }, payload) => {
            commit('workFlowStatusIdChange', { rootState, payload });
        },

        initiativeIdChange: ({ commit, rootState }, payload) => {
            commit('initiativeIdChange', { rootState, payload });
        },
        //#. recordAdded event will be fired
        beforeUpdated: ({ commit, rootState }, payload) => {
        }
    }
}
